module.exports = __webpack_public_path__ + "img/404.4a7ba3be.jpg";